var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-form-group",
    {
      attrs: {
        "label-cols": "7",
        "label-cols-sm": "6",
        "label-align-sm": "right",
      },
      scopedSlots: _vm._u([
        {
          key: "label",
          fn: function () {
            return [
              _vm._v("Undermount"),
              _c("br"),
              _c("small", [
                _c("em", [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.undermount",
                          modifiers: { undermount: true },
                        },
                      ],
                      attrs: { href: "#" },
                    },
                    [_vm._v("What is an undermount?")]
                  ),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "b-form-checkbox",
        {
          staticClass: "pt-1",
          attrs: { size: "lg" },
          model: {
            value: _vm.includeUndermount,
            callback: function ($$v) {
              _vm.includeUndermount = $$v
            },
            expression: "includeUndermount",
          },
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.price !== `0.00`,
                  expression: "price !== `0.00`",
                },
              ],
              staticClass: "um-price",
            },
            [_vm._v("(£" + _vm._s(_vm.price) + " each)")]
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "undermount",
            title: "What is undermount?",
            size: "lg",
            "ok-only": "",
          },
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "4" } }, [
                _c("img", {
                  attrs: {
                    src: "/images/framing_accessories/mountboard/mount-corner-1.jpg",
                  },
                }),
              ]),
              _c("b-col", { attrs: { cols: "8" } }, [
                _c("p", [
                  _vm._v("Whitecore 1400 micron (1.4mm) thick mountboard. "),
                ]),
                _c("p", [
                  _vm._v(
                    " This mountboard is suitable for mounting your artwork onto. The purpose is to be used as a barrier between the artwork and the backing board, \n and prevents the transfer of damaging chemicals from non-certified backing boards onto artwork substrates."
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    "One face of the undermount board is Snow White (#8001), and the other face is Minuet (#8627)."
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }